import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import { useInstance } from 'intact-vue-next';
import { useReceive } from '../../hooks/useReceive';
export function useMarks() {
  var instance = useInstance();
  var marks = [];
  useReceive(['marks', 'value'], function () {
    var _instance$get = instance.get(),
      max = _instance$get.max,
      min = _instance$get.min,
      _marks = _instance$get.marks;
    marks = [];
    for (var key in _marks) {
      var mark = _marks[key];
      var value = +key;
      marks.push({
        value: value,
        raw: mark,
        style: {
          left: (value - min) / (max - min) * 100 + '%'
        },
        active: false,
        text: ''
      });
    }
    addText();
  });
  instance.on('$change:value', addText);
  function addText() {
    var _instance$get2 = instance.get(),
      value = _instance$get2.value,
      range = _instance$get2.range;
    marks.forEach(function (mark) {
      var active = !range ? mark.value === value : _includesInstanceProperty(value).call(value, mark.value);
      var text;
      var raw = mark.raw;
      if (Array.isArray(raw)) {
        text = active && raw[1] !== undefined ? raw[1] : raw[0];
      } else {
        text = raw;
      }
      mark.active = active;
      mark.text = text;
    });
  }
  return function () {
    return marks;
  };
}